import {
  formatWeightWithUnit,
  formatDistanceWithUnit,
  displayWeightToKg,
  displayDistanceToKm,
  type UnitSystem,
} from "./units";

/**
 * Rewrite weight/distance tokens in AI or UI text to match the user's unit preference.
 * - Imperial: kg/km → lb/mi
 * - Metric: lb/mi → kg/km
 */
export function rewriteMetricUnitsInText(text: string, units: UnitSystem): string {
  if (!text) return text;

  if (units === "imperial") {
    return text
      .replace(/(\d+(?:\.\d+)?)\s*kg\b/gi, (_m, n) => {
        const kg = parseFloat(n);
        if (!Number.isFinite(kg)) return _m;
        return formatWeightWithUnit(kg, "imperial", 0);
      })
      .replace(/(\d+(?:\.\d+)?)\s*kilograms?\b/gi, (_m, n) => {
        const kg = parseFloat(n);
        if (!Number.isFinite(kg)) return _m;
        return formatWeightWithUnit(kg, "imperial", 0);
      })
      .replace(/(\d+(?:\.\d+)?)\s*km\b/gi, (_m, n) => {
        const km = parseFloat(n);
        if (!Number.isFinite(km)) return _m;
        return formatDistanceWithUnit(km, "imperial");
      })
      .replace(/(\d+(?:\.\d+)?)\s*kilometers?\b/gi, (_m, n) => {
        const km = parseFloat(n);
        if (!Number.isFinite(km)) return _m;
        return formatDistanceWithUnit(km, "imperial").replace(/\bmi\b/, "miles");
      })
      .replace(/\/\s*km\b/gi, "/mi")
      .replace(/\bper\s+kilometer\b/gi, "per mile")
      .replace(/\bmin(?:ute)?s?\s*\/\s*km\b/gi, "min/mi");
  }

  // Metric: convert imperial tokens so switching units updates chat/workout copy
  return text
    .replace(/(\d+(?:\.\d+)?)\s*lbs?\b/gi, (_m, n) => {
      const lb = parseFloat(n);
      if (!Number.isFinite(lb)) return _m;
      return formatWeightWithUnit(displayWeightToKg(lb, "imperial"), "metric", 1);
    })
    .replace(/(\d+(?:\.\d+)?)\s*pounds?\b/gi, (_m, n) => {
      const lb = parseFloat(n);
      if (!Number.isFinite(lb)) return _m;
      return formatWeightWithUnit(displayWeightToKg(lb, "imperial"), "metric", 1);
    })
    .replace(/(\d+(?:\.\d+)?)\s*mi(?:les?)?\b/gi, (_m, n) => {
      const mi = parseFloat(n);
      if (!Number.isFinite(mi)) return _m;
      return formatDistanceWithUnit(displayDistanceToKm(mi, "imperial"), "metric");
    })
    .replace(/\/\s*mi\b/gi, "/km")
    .replace(/\bper\s+mile\b/gi, "per kilometer")
    .replace(/\bmin(?:ute)?s?\s*\/\s*mi\b/gi, "min/km");
}
